<div class="default-space-between-components flyer">
    <div [ngStyle]="{'background-image': 'url(' + backgroundImage + ')'}" class="container-flyer">
        <div class="rs-wrapper-v4">
            <ng-content>
            </ng-content>
        </div>
    </div>
</div>